import { useEffect, useState } from 'react';
import { kayaCRUD } from '../../../actions/kaya';
import { Loading } from '../../constant';
import { PersonalDetail, ResidentialDetail, RegistrationDetail, OtherDetail, DeathDetail } from "./detail"


export const MemberDetail = (props) => {

  const {dataId} = props
  const [memberLoading, setMemberLoading] = useState(false)
  const [data, setData] = useState({})

  const [step1, setStep1] = useState(false)
  const [step2, setStep2] = useState(false)
  const [step3, setStep3] = useState(false)
  const [step4, setStep4] = useState(false)

  useEffect(() => {
    if (!dataId) return;

    setMemberLoading(true)
    setTimeout(() => {
      kayaCRUD.loadMemberUpdate(dataId).then((resp) => {
        setData(resp.data)
      }).finally(() => {
        setMemberLoading(false)
      })
    }, 500)
  },[dataId])

  return (
    <>
      <div className="modal fade detailModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="myLargeModalLabel">{data.full_name ? (data.full_name).toUpperCase() : 'Member Detail'}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr/>
            <div className="modal-body">
            {memberLoading ?
                <Loading/>
               :
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-body">
                            <form action="#" class="form-steps" autocomplete="off">
                                <div class="step-arrow-nav mb-4">
                                    <ul class="nav nav-pills custom-nav nav-justified" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button className={!step1 ? "nav-link active" : "nav-link"} id="steparrow-per-info-tab" data-bs-toggle="pill" data-bs-target="#steparrow-per-info" type="button" role="tab" aria-controls="steparrow-per-info" aria-selected="true">Personal</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button className={step2 ? 'nav-link' : !step1 ? 'nav-link' : 'nav-link active'}id="steparrow-res-info-tab" data-bs-toggle="pill" data-bs-target="#steparrow-res-info" type="button" role="tab" aria-controls="steparrow-res-info" aria-selected="false">Residential</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button className={step3 ? 'nav-link' : !step2 ? 'nav-link' : 'nav-link active'} id="steparrow-reg-info-tab" data-bs-toggle="pill" data-bs-target="#steparrow-reg-info" type="button" role="tab" aria-controls="steparrow-reg-info" aria-selected="false">Registration</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button className={step4 ? 'nav-link' : !step3 ? 'nav-link' : 'nav-link active'} id="steparrow-other-info-tab" data-bs-toggle="pill" data-bs-target="#steparrow-other-info" type="button" role="tab" aria-controls="steparrow-other-info" aria-selected="false">Other Details</button>
                                        </li>
                                        {data.is_dead &&
                                        <li class="nav-item" role="presentation">
                                            <button className={step4 ? "nav-link active" : "nav-link"} id="pills-death-tab" data-bs-toggle="pill" data-bs-target="#pills-death" type="button" role="tab" aria-controls="pills-death" aria-selected="false">Death Details</button>
                                        </li>
                                        }
                                    </ul>
                                </div>
                                <div class="tab-content">
                                    <div className={!step1 ? "tab-pane fade show active" : "tab-pane fade"} id="steparrow-per-info" role="tabpanel" aria-labelledby="steparrow-per-info-tab">
                                        <PersonalDetail data={data} step1={step1} setStep1={setStep1}/>
                                    </div>
                                    
                                    <div className={step2 ? "tab-pane fade" : !step1 ? "tab-pane fade" : "tab-pane fade show active"} id="steparrow-res-info" role="tabpanel" aria-labelledby="steparrow-res-info-tab">
                                        <ResidentialDetail data={data} step2={step2} setStep2={setStep2} step1={step1} setStep1={setStep1}/>
                                    </div>
                                    
                                    <div className={step3 ? "tab-pane fade" : !step2 ? "tab-pane fade" : "tab-pane fade show active"} id="steparrow-reg-info" role="tabpanel" aria-labelledby="steparrow-reg-info-tab">
                                      <RegistrationDetail data={data} step2={step2} setStep2={setStep2} step3={step3} setStep3={setStep3}/>
                                    </div>

                                    <div className={step4 ? "tab-pane fade" : !step3 ? "tab-pane fade" : "tab-pane fade show active"} id="steparrow-other-info" role="tabpanel" aria-labelledby="steparrow-other-info-tab">
                                        <OtherDetail data={data} step3={step3} setStep3={setStep3} step4={step4} setStep4={setStep4}/>
                                    </div>
                                    {data.is_dead &&
                                    <div className={step4 ? "tab-pane fade show active" : "tab-pane fade"} id="pills-death" role="tabpanel">
                                        <DeathDetail data={data} step4={step4} setStep4={setStep4}/>
                                    </div>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            }
            </div>
            <div className="modal-footer">
              {/* <a href="javascript:void(0);" className="btn btn-outline-danger fw-medium" data-bs-dismiss="modal"><i className="ri-close-line me-1 align-middle"></i> Close</a>
              <button type="button" className="btn btn-success ">
                <i className="las la-save la-lg"></i> &nbsp; Save changes
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )

}